'use client';

import { cn } from '@/lib/utils';

const PriceElement = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <span className={cn('space-x-2', className)}>{children}</span>;
};

export const DietActions = ({
  children,
  variant,
}: {
  children?: React.ReactNode;
  variant?: 'big' | 'small';
}) => {
  return (
    <div
      className={cn('border-border border-t', {
        'lg:border-l lg:border-t-0': variant === 'big',
      })}
    >
      <div
        className={cn(
          'flex flex-col items-center justify-between space-y-2 p-4 sm:flex-row sm:space-y-0',
          {
            'lg:aspect-square lg:h-full lg:w-full lg:flex-col lg:justify-center lg:space-y-4':
              variant === 'big',
          },
        )}
      >
        {children}
      </div>
    </div>
  );
};

function AddToCard(props: { children: React.ReactNode }) {
  return <>{props.children}</>;
}

DietActions.PriceElement = PriceElement;
DietActions.AddToCard = AddToCard;
